import { logger } from '../../logger';
import {
    ICarrierStoreEventHandler,
    ParcelConfirmedParameters,
    ParcelScannedParameters, ParcelScannedResult,
    ParcelStoreCancelledParameters
} from './ICarrierStoreEventHandler';
import { ScanRequest, UpsRestClient } from '../../rest-clients/UpsRestClient';
import { DateTime } from 'luxon';

const log = logger.sub("UpsCarrierStoreEventHandler");

export class UpsCarrierStoreEventHandler implements ICarrierStoreEventHandler {
    async parcelScanned(params: ParcelScannedParameters): Promise<ParcelScannedResult | undefined> {
        throw new Error("UPS carrier store parcel scanned event not implemented");
    }

    async parcelStoreCancelled(params: ParcelStoreCancelledParameters): Promise<void> {
        throw new Error("UPS carrier store parcel store cancelled event not implemented");
    }

    async parcelStoreConfirmed(params: ParcelConfirmedParameters): Promise<void> {
        const { parcelId, backendApiCredentials, cubeId, isAdhocDelivery } = params;
        if (!isAdhocDelivery) {
            log.info(`Called ups carrier store parcel done handler for ${parcelId}, which is not ad-hoc delivery. Doing nothing.`);
            return;
        }
        log.info(`Called ups carrier store parcel done handler for ${parcelId}`);
        const { baseUrl, token } = backendApiCredentials;
        const upsRestClient = new UpsRestClient(baseUrl, token, cubeId);
        const request: ScanRequest = {
            event: 'AP_POSSESSION_FROM_UPS',
            scanDateTime: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss.SSS'),
            trackingNumber: parcelId,
        };
        const response = await upsRestClient.sendScanEvent(request);
        if (!response.ok || !response.body.success) {
            throw new Error(JSON.stringify(response.body));
        }
    }
}